import Skeleton from '@mui/material/Skeleton';
import { Link } from 'react-router-dom';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Constant from '../../Constant';

function ActiveSavingsCom({ img, title, sub, onClick, link, loading, state }) {
  if (loading) {
    return (
      <div className=' my-4 rounded-lg border border-[#D2D3D5] p-4'>
        <div className=' flex gap-3 items-center'>
          <Skeleton variant="rectangular" width={48} height={48} sx={{ borderRadius: 2 }} />
          <div className='w-full'>
            <Skeleton variant="text" width="60%" height={25} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="40%" height={30} />
          </div>
          <div className='pt-2'>
            <Skeleton variant="circular" width={24} height={24} />
          </div>
        </div>
      </div>
    )
  }
  const Content = (
    <div className=' flex gap-3 cursor-pointer justify-between items-center' onClick={onClick}>
      <div className=' flex gap-3 items-center overflow-hidden'>
        <img src={img} alt='' className=' w-12 h-12 flex-shrink-0 object-contain' />
        <div className=' overflow-hidden'>
          <p className=' text-[14px] capitalize text-[#808285] mb-1 truncate'>{title} </p>
          <p className=' text-[16px] font-[500] text-[#002615] whitespace-nowrap'>₦{Constant.FormatNumber(sub)}</p>
        </div>
      </div>
      <div className=' flex-shrink-0'>
        <KeyboardArrowRightIcon className='  text-back-color2 cursor-pointer' />
      </div>
    </div>
  );

  return (
    <div className=' my-4 rounded-lg border border-[#D2D3D5] p-4'>
      {link ? (
        <Link to={link} state={state}>
          {Content}
        </Link>
      ) : (
        Content
      )}
    </div>
  )
}

export default ActiveSavingsCom;
